import { render, staticRenderFns } from "./CostBearerPreviewPdfDocument.vue?vue&type=template&id=5515807c&scoped=true&"
import script from "./CostBearerPreviewPdfDocument.vue?vue&type=script&lang=ts&"
export * from "./CostBearerPreviewPdfDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515807c",
  null
  
)

export default component.exports